export default __webpack_public_path__ + "static/media/InstallDockerAgent2Ecs.81a8ac76.md";